export const environment = {
  debug: false,
  // DEVELOPMENT
  production: false,
  shareBaseUrl: 'https://staging-fe.socialtravels.it/',
  //shareBaseUrl: 'http://localhost:4200/',

  baseUrl: 'https://staging-api.socialtravels.it',
  // baseUrl: 'http://localhost:3000',
  mediaUrl: 'https://storage-dev.zetra.it/media/st-dev',
  fileUrl:
    'http://storage-dev.zetra.it/api/v1/download-shared-object/aHR0cDovLzEyNy4wLjAuMTo5MDAwL3N0LWRldi9hZGRyZXNzLWJvb2sueGxzeD9YLUFtei1BbGdvcml0aG09QVdTNC1ITUFDLVNIQTI1NiZYLUFtei1DcmVkZW50aWFsPVo5Qk1WWlZYMDlUM0owN0k0T0VEJTJGMjAyNDA3MDklMkZ1cy1lYXN0LTElMkZzMyUyRmF3czRfcmVxdWVzdCZYLUFtei1EYXRlPTIwMjQwNzA5VDEwMzgwOVomWC1BbXotRXhwaXJlcz00MzIwMCZYLUFtei1TZWN1cml0eS1Ub2tlbj1leUpoYkdjaU9pSklVelV4TWlJc0luUjVjQ0k2SWtwWFZDSjkuZXlKaFkyTmxjM05MWlhraU9pSmFPVUpOVmxwV1dEQTVWRE5LTURkSk5FOUZSQ0lzSW1WNGNDSTZNVGN5TURVMk5EWXpNU3dpY0dGeVpXNTBJam9pV21WMGNtRkVaWFpOYVc1cGIwRmtiV2x1SW4wLlpmeDIydnh1cUZhTzkyOVRPeUkwdHZVREVucnVpaWROMUwwd1lwcnR3MW9sZXYycWdSQ0xjRzc1U0hjaFdrRXpXT2ZsdE1VUUpPZ3I1dDVLRzc3NlBBJlgtQW16LVNpZ25lZEhlYWRlcnM9aG9zdCZ2ZXJzaW9uSWQ9bnVsbCZYLUFtei1TaWduYXR1cmU9NTYxZWRlZmYwZDQ5MGUzZGZjYWI4NzRmYTk1MTMyZjJiNTYxZDg0NzUxY2RjM2VhYjgxNmNlNGI2ZmExNDJiMw',
};
